import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateSmsTemplateForm from "../../forms/CreateOrUpdateSmsTemplateForm";

interface CreateSmsTemplateModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateSmsTemplateModal: React.FC<CreateSmsTemplateModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Create New SMS Template"
      width="sm"
      loading={loading}
    >
      <CreateOrUpdateSmsTemplateForm loading={loading} error={error} />
    </AppModal>
  );
};

export default CreateSmsTemplateModal;
